export default {
  deepMerge: deepMerge,
  pick: pick,
  unescapeHTML: unescapeHTML,
  deepUnescapeHTML: deepUnescapeHTML,
  empty: empty,
}

// https://stackoverflow.com/a/34749873/7407846
function deepMerge(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        deepMerge(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return deepMerge(target, ...sources)
}

function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item))
}

function isString(item) {
  return (typeof item === 'string' || item instanceof String)
}

function isArray(item) {
  return (typeof item === 'array' || item instanceof Array)
}

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_pick
function pick(object, keys) {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}

// https://www.30secondsofcode.org/js/s/unescape-html
function unescapeHTML(str) {
  if (!isString(str)) {
    return str
  }

  return str.replace(
    /&amp;|&lt;|&gt;|&#39;|&quot;/g,
    tag =>
    ({
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&#39;': "'",
      '&quot;': '"'
    }[tag] || tag)
  );
}

function deepUnescapeHTML(object) {
  if (isString(object)) {
    return unescapeHTML(object)
  }

  if (isArray(object)) {
    return object.map(obj => deepUnescapeHTML(obj))
  }

  if (isObject(object)) {
    const newObj = {};
    Object.keys(object).forEach((k) => {
      return newObj[k] = deepUnescapeHTML(object[k]);
    })

    return newObj
  }

  return object
}

// https://github.com/jquery/jquery/blob/de5398a6ad088dc006b46c6a870a2a053f4cd663/src/core.js#L222
function empty(obj) {
  for (var i in obj) return false
  return true
}
